<template>
  <div class="fourMethods-wrap">
    <app-header />
    <div class="auto1200">
      <div class="validation-box">
        <form action="">
          <div class="group">
            <input type="number" name="" id="" placeholder="请输入手机号" v-model="tel" @input="changeInputValue" ref="inputTel">
          </div>
          <div class="group">
            <input type="text" name="" id="" placeholder="请输入验证码" v-model="code">
            <span :class="{disabled: isDisabled}" @click="getCode">{{codeText}}</span>
          </div>
          <button type="button" class="button" :class="{enlarge: isEnlarge}" @click="getGift">立即体验</button>
        </form>
      </div>
      <ul class="info-list">
        <li>
          <p>黄金波段</p>
          <span>红蓝交替，短期提醒</span>
        </li>
        <li>
          <p>智慧动向</p>
          <span>结合资金动向，寻找投资机会</span>
        </li>
        <li>
          <p>市场热度</p>
          <span>热度高低体现盈亏难易</span>
        </li>
        <li>
          <p>黄金狙击</p>
          <span>狙击变盘窗口，预知趋势扭转</span>
        </li>
      </ul>
      <div class="content">
        <h2 class="title"></h2>
        <div class="item">
          <div class="text">
            <div>
              <i>603816</i>
              <span>顾家家居</span>
              <em>62.24</em>
              <em>+0.50%</em>
            </div>
            <div>信号时间：2020/10/27 11:11</div>
            <div>
              <span>信号后至次日收盘</span>
              <em>+13.12%</em>
            </div>
          </div>
          <div class="img">
            <img src="../../assets/images/activity/fourMethods/img1.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="sub-title">《黄金波段》：多指标结合，判断短线趋势</div>
          <div class="img">
            <img src="../../assets/images/activity/fourMethods/img2.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="sub-title">《市场热度》：全方位监控市场氛围，人气信号预警提示</div>
          <div class="img">
            <img src="../../assets/images/activity/fourMethods/img3.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="sub-title">《智慧动向》：深挖中短期活跃资金动向，为投资者寻找投资机会</div>
          <div class="img">
            <img src="../../assets/images/activity/fourMethods/img4.png" alt="">
          </div>
        </div>
        <p class="note">成功案例仅作展示，不作为投资依据。</p>
      </div>
      <div class="tips">
        <span>活动须知：</span>
        <p>四维战法为大智慧365(电脑端)炒股指标，功能自领取日起15天有效，尽快用注册的手机号登录使用哦！</p>
      </div>
    </div>
    <div class="sideBar">
      <ul>
        <li @click="changeEnlarge">立即体验</li>
        <li @click="activityGoUrl(token,116)">直接购买</li>
        <li><a href="http://help123.gw.com.cn/help123/index.php?_url=/index/single&post_id=11416" target="_blank">历史案例</a></li>
        <li><a href="http://tg.gw.com.cn/gwhome.php?type=32">下载软件</a></li>
        <li @mousemove="isPopTel = true" @mouseout="isPopTel = false">服务热线
          <div class="innerCon" v-show="isPopTel">021-20219999</div>
        </li>
      </ul>
      <span class="back-top" @click="goBack">回顶部</span>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import mixins from '@/mixins/index.js'
export default {
  nama: 'fourMethods',
  mixins: [mixins],
  data() {
    return{
      token:'',
      isPopTel: false, // 电话浮框
      isEnlarge: false, // 按钮是否变大
      isDisabled: false, // 按钮是否不可用
      count: 60, // 倒计时数字
      timer: '', // 定时器
      codeText: '获取验证码', // 验证码文本
      tel:'', // 手机号
      code:'', // 验证码
      params: {
        productId: 333,
        month: 15
      },
    }
  },
  created() {

  },
  methods: {
    // 按钮变大
    changeEnlarge() {
      window.scrollTo(0,0);
      if(this.isEnlarge === true) return;
      this.isEnlarge = true;
      setTimeout(()=>{
        this.isEnlarge = false;
      },1000)
    },
    // 返回顶部
    goBack() {
      window.scrollTo(0,0);
    },
    changeInputValue() {
      this.$refs.inputTel.value = this.tel
    },
    // 获取验证码
    getCode() {
      console.log(this.tel)
      if(!this.tel.trim()) {
        this.$global.alert('请输入手机号');
        return;
      }
      if(!this.$validate.checkPhone(this.tel)) {
        this.$global.alert('手机号码格式不正确');
        return;
      }
      if(this.isDisabled === true) return;
      this.params.mobile = this.tel;
      this.$post('/activity/free333Sms',this.params)
        .then(response=>{
          console.log(response);
          if(response.code === 0) {
            this.isDisabled = true;
            this.codeText = this.count + 's';
            this.timer = setInterval(() => {
              this.count--;
              this.codeText = this.count + 's';
              if(this.count <=0) {
                clearInterval(this.timer);
                this.codeText = '获取验证码';
                this.isDisabled = false;
                this.count = 60;
              }
            }, 1000);
          } else {
            this.$global.alert(response.msg);
          }
        })
      
    },
    // 获取体验
    getGift() {
      if(this.tel.trim() === '') {
        this.$global.alert('请输入手机号');
        return;
      }
      if(!this.$validate.checkPhone(this.tel)) {
        this.$global.alert('手机号码格式不正确');
        return;
      }
      if(this.code.trim() === '') {
        this.$global.alert('请输入验证码');
        return;
      }
      this.params.mobile = this.tel ;
      this.params.captcha = this.code;
      this.$post('/activity/free333Save',this.params)
        .then(response=>{
          console.log(response);
          if(response.code === 0) {
            this.$global.alert(`恭喜您！领取成功。
            已开通大智慧四维战法指标，有效期15天。
            如有疑问，请致电021-20219999
            `);
          } else {  
            this.$global.alert(response.msg);
          }
        })
        .catch(err=>{
          this.$global.alert('网络异常，请稍后重试。');
        })
    }
  },
  components: {
    AppHeader
  }
}
</script>
<style>
  @keyframes enlargeAni {
    0%{
      transform: scale(1);
    }
    50%{
      transform: scale(1.1);
    }
    100%{
     transform: scale(1);
    }
  }
</style>
<style lang="scss" scoped>
input[type=number]{
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button{
    -webkit-appearance: none;
  }
  -moz-appearance: textfield;
}
.fourMethods-wrap{
  background: url(../../assets/images/activity/fourMethods/bg1.jpg) no-repeat center 100px,
              url(../../assets/images/activity/fourMethods/bg2.jpg) no-repeat center 1100px,
              url(../../assets/images/activity/fourMethods/bg3.jpg) no-repeat center 2100px,
              url(../../assets/images/activity/fourMethods/bg4.jpg) no-repeat center 3100px,
              url(../../assets/images/activity/fourMethods/bg5.jpg) no-repeat center 4101px,
              url(../../assets/images/activity/fourMethods/bg6.jpg) no-repeat center 5101px #00007a;
  .auto1200{width: 1200px;margin: 0 auto;}
  .validation-box{
    padding-top: 364px;
    width: 544px;
    margin: 0 auto;
    .group{
      width: 480px;
      margin: 0 auto;
      input{
        background: #fff;
        padding: 10px 20px;
        height: 48px;
        box-sizing: border-box;
        width: 100%;
        border-radius: 8px;
        font-size: 21px;
        color: #333;
        letter-spacing: 1px;
        &::placeholder{
          color: #9a9a9a;
        }
      }
      &:nth-of-type(2){
        overflow: hidden;
        margin: 18px auto 0px;
        input{
          float: left;
          width: 310px;
        }
        span{
          @include center-text(158px, 48px);
          display: block;
          background: #0675fe;
          float: right;
          @include fc(24px, #fff);
          border-radius: 8px;
          cursor: pointer;
          &.disabled{
            background: #cccccc;
            color: #343434;
          }
        }
      }
    }
    .button{
      display: block;
      width: 544px;
      height: 138px;
      background: url(../../assets/images/activity/fourMethods/button.png) no-repeat;
      outline: 0;
      border: 0;
      text-indent: -9999em;
      cursor: pointer;
      &.enlarge{
        animation: enlargeAni 0.5s linear 0s infinite alternate;
      }
    }
  }
  .info-list{
    padding-top: 400px;
    overflow: hidden;
    width: 100%;
    li{
      float: left;
      text-align: center;
      &:nth-child(1){
        margin-left: 30px;
      }
      +li{
        margin-left: 90px;
      }
      p{
        @include fc(40px, #fff);
        margin-bottom: 20px;
      }
      span{
        display: block;
        @include fc(20px, #ffcb67);
      }
    }
  }
  .content{
    margin-top: 225px;
    border: 4px solid #fff;
    box-shadow: 0px 0px 15px 5px #d708bd;
    border-radius: 20px;
    padding: 75px 30px 20px;
    position: relative;
    .title{
      background: url(../../assets/images/activity/fourMethods/title.png) no-repeat;
      @include wh(781px, 150px);
      position: absolute;
      top: -80px;
      left: 50%;
      margin-left: -390px;
    }
    .item{
      background: #fff;
      border-radius: 20px;
      padding: 20px 10px 30px;
      +.item{
        margin-top: 40px;
      }
      .text{
        overflow: hidden;
        margin-bottom: 20px;
        >div{
          float: left;
          @include fc(24px, #000);
          line-height: 1;
          +div{
            margin-left: 50px;
            margin-top: 6px;
          }
          >em{
            color: #eb1b1b;
            margin-left: 5px;
          }
          &:nth-child(1){
            background: #f0f0f0;
            padding: 5px 15px;
            border-radius: 30px;
            >i{
              color: #686868;
            }
          }
        }
      }
      .sub-title{
        @include fc(36px, #8b04cc);
        text-align: center;
        margin-bottom: 25px;
      }
      .img{
        img{
          display: block;
          margin: 0 auto;
        }
      }
    }
    .note{
      @include fc(18px, #ccc);
      margin: 20px auto 0;
      text-align: center;
    }
  }
  .tips{
    margin: 30px 30px 0;
    padding-bottom: 50px;
    @include fc(30px, #fff);
    overflow: hidden;
    line-height: 40px;
    span{
      float: left;
      margin-right: 5px;
    }
    p{
      float: left;
      width: 980px;
    }
  }
  .sideBar{
    position: fixed;
    top: 100px;
    right: 10px;
    // margin-right: -700px;
    ul{
      background: #1b79c6;
      border: 1px solid #4ca1e6;
      width: 92px;
      li{
        @include fc(16px, #fff);
        text-align: center;
        box-sizing: border-box;
        padding-bottom: 11px;
        cursor: pointer;
        position: relative;
        a{
          color: #fff;
        }
        &:nth-child(1){
          &:before{
            background: url(../../assets/images/activity/fourMethods/icon-experience.png) no-repeat;
          }
        }
        &:nth-child(2){
          &:before{
            background: url(../../assets/images/activity/fourMethods/icon-buy.png) no-repeat;
          }
        }
        &:nth-child(3){
          a:before{
            background: url(../../assets/images/activity/fourMethods/icon-case.png) no-repeat;
          }
        }
        &:nth-child(4){
          a:before{
            background: url(../../assets/images/activity/fourMethods/icon-down.png) no-repeat;
            height: 27px;
          }
        }
        &:nth-child(5){
          &:before{
            background: url(../../assets/images/activity/fourMethods/icon-tel.png) no-repeat;
            width: 38px;
          }
        }
        &:nth-child(1),&:nth-child(2),&:nth-child(5){
          &:before{
            content: '';
            display: block;
            @include wh(32px, 32px);
            margin: 11px auto 11px;
          }
        }
        &:nth-child(3),&:nth-child(4){
          a:before{
            content: '';
            display: block;
            @include wh(32px, 32px);
            margin: 11px auto 11px;
          }
        }
        +li{
          border-top: 1px solid #4ca1e6;
        }
        .innerCon{
          @include center-box-y;
          right: 100px;
          background: #1b79c6;
          border: 1px solid #4ca1e6;
          width: 130px;
          line-height: 40px;
        }
      }
    }
    .back-top{
      width: 80px;
      background: rgba($color: #155d98, $alpha: 0.7);
      @include fc(16px, #fff);
      text-align: center;
      display: block;
      padding: 10px 0;
      margin: 10px auto 0;
      cursor: pointer;
      &:before{
        content: '';
        display: block;
        @include wh(22px, 22px);
        margin: 0px auto 11px;
        background: url(../../assets/images/activity/fourMethods/icon-backup.png) no-repeat;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/FourMethods.vue